import { regexExecAll } from '../utils/regexExecAll'
import { replaceFirst } from '../utils/replaceFirst'
import { frontOperatorValuesToAql } from '../utils/operatorValuesToAql'
import { regexpCaptureGroupsToSearchOperatorConfig } from '../utils/searchOperatorConfig'
import { YEAR_AND_ODO_AQL_PATTERN, YEAR_AQL_PATTERN } from '../../regexp'
import type { OdometerOperator } from '../../enums/SearchOperators'
import type { AllDashboardCardFilters, SearchOperatorConfig } from '../../types'

const EMPTY_ODO_CONFIG = { odo: '', odoLow: '', odoHigh: '' } as const

export const parseOdometer = (aql: string): Pick<AllDashboardCardFilters, 'odo' | 'odoLow' | 'odoHigh'> => {
    if (!aql) {
        return EMPTY_ODO_CONFIG
    }

    const allYearOdoMatches = regexExecAll(aql, YEAR_AND_ODO_AQL_PATTERN)

    if (!allYearOdoMatches?.length) {
        return EMPTY_ODO_CONFIG
    }

    const firstOdoConfig = allYearOdoMatches.reduce<SearchOperatorConfig | null>((acc, match) => {
        if (acc) {
            return acc
        }

        const config = regexpCaptureGroupsToSearchOperatorConfig(match.groups)

        if (!config.operator || !config.lowValue) {
            return null
        }

        const filterRegex = new RegExp(YEAR_AQL_PATTERN)
        const shouldFilterMatch = filterRegex.test(config.lowValue)

        if (shouldFilterMatch) {
            return null
        }

        return config
    }, null)

    if (!firstOdoConfig) {
        return EMPTY_ODO_CONFIG
    }

    const { operator, lowValue, highValue } = firstOdoConfig
    return { odo: operator as OdometerOperator, odoLow: lowValue, odoHigh: highValue }
}

export const updateOdomter = (
    prior: string,
    operator: OdometerOperator | '' = '',
    lowValue = '',
    highValue = '',
): string => {
    const valueWithOperator = frontOperatorValuesToAql({ operator, lowValue, highValue })
    const regex = new RegExp(YEAR_AND_ODO_AQL_PATTERN, 'g')
    const filterRegex = new RegExp(YEAR_AQL_PATTERN)

    return replaceFirst(prior, regex, valueWithOperator, {
        handleNotFound: 'append',
        removeOtherMatches: true,
        filter: (match) => filterRegex.test(match),
    })
}
